import { useMediaQuery } from '@mui/material';
import { useTheme } from '@core/contexts/ThemeContext';

export function useIsMobile(): boolean {
  const { theme } = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
